import { getGames, GAME } from '@/utils/game'

const games = getGames()

export default [
  {
    key: 'name',
    label: 'field.name',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'phone',
    label: 'field.phoneNumber',
    rules: 'required',
    type: 'tel',
  },
  {
    key: 'channelIds',
    label: 'field.channel',
    rules: '',
    type: 'nAsynMultiSelection',
    repository: 'channel',
    selectionKey: 'id',
    selectionLabel: 'channelName',
  },
  {
    key: 'loginTimeout',
    label: 'field.loginTimeout',
    rules: 'required|integer',
    type: 'text',
  },
  {
    key: 'state',
    label: 'field.an',
    rules: 'required',
    type: 'text',
  },
  {
    label: 'breadcrumb.channel1',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTime',
    label: 'field.minBetTime',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTime',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGame',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxDrawBetGame',
    label: 'field.maxDrawBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDay',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.channel2',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeTwo',
    label: 'field.minBetTime',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeTwo',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameTwo',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameTwo',
    label: 'field.maxDrawBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayTwo',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.channel3',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeThree',
    label: 'field.minBetTime',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeThree',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameThree',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameThree',
    label: 'field.maxDrawBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayThree',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.channel4',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeFour',
    label: 'field.minBetTime',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeFour',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameFour',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameFour',
    label: 'field.maxDrawBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayFour',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.channel5',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeFive',
    label: 'field.minBetTime',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeFive',
    label: 'field.maxBetTime',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameFive',
    label: 'field.maxBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameFive',
    label: 'field.maxDrawBetGame',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayFive',
    label: 'field.maxWinDay',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.baccarat1',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeBacar',
    label: 'field.minBetTimeBacar',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeBacar',
    label: 'field.maxBetTimeBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameBacar',
    label: 'field.maxBetGameBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameBacar',
    label: 'field.maxDrawBetGameBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayBacar',
    label: 'field.maxWinDayBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'commissionBacar',
    label: 'field.commissionPercentage',
    rules: 'required|max_value:100|decimal:2',
    type: 'currency',
  },
  {
    label: 'breadcrumb.baccarat2',
    icon: 'TvIcon',
    type: 'divider',
  },
  {
    key: 'minBetTimeBacarTwo',
    label: 'field.minBetTimeBacar',
    rules: 'decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetTimeBacarTwo',
    label: 'field.maxBetTimeBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetGameBacarTwo',
    label: 'field.maxBetGameBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxBetDrawPerGameBacarTwo',
    label: 'field.maxDrawBetGameBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'maxWinDayBacarTwo',
    label: 'field.maxWinDayBacar',
    rules: 'required|decimal:2',
    type: 'currency',
  },
  {
    key: 'commissionBacarTwo',
    label: 'field.commissionPercentage',
    rules: 'required|max_value:100|decimal:2',
    type: 'currency',
  },
  ...(games.includes(GAME.Joker) ? [
    {
      label: 'breadcrumb.slotMachine',
      icon: 'TvIcon',
      type: 'divider',
    },
    {
      key: 'maxWinDayJoker',
      label: 'field.maxWinDay',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxLoseDayJoker',
      label: 'field.maxLoseDay',
      rules: 'decimal:2',
      type: 'currency',
    },
  ] : []),
  ...(games.includes(GAME.Lotto) ? [
    {
      label: 'breadcrumb.lotto',
      icon: 'TvIcon',
      type: 'divider',
    },
    {
      key: 'maxBetTimeLotto',
      label: 'field.maxBetTime',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxBetGameLotto',
      label: 'field.maxBetGame',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxWinDayLotto',
      label: 'field.maxWinDay',
      rules: 'decimal:2',
      type: 'currency',
    },
  ] : []),
  ...(games.includes(GAME.Lotto12) ? [
    {
      label: 'breadcrumb.lotto12',
      icon: 'TvIcon',
      type: 'divider',
    },
    {
      key: 'maxBetTimeLotto12',
      label: 'field.maxBetTime',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxBetGameLotto12',
      label: 'field.maxBetGame',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxWinDayLotto12',
      label: 'field.maxWinDay',
      rules: 'decimal:2',
      type: 'currency',
    },
  ] : []),
  ...(games.includes(GAME.Vn99) ? [
    {
      label: 'breadcrumb.lottery',
      icon: 'TvIcon',
      type: 'divider',
    },
    {
      key: 'maxBetTimeLottery',
      label: 'field.maxBetTime',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxBetGameLottery',
      label: 'field.maxBetGame',
      rules: 'decimal:2',
      type: 'currency',
    },
    {
      key: 'maxWinDayLottery',
      label: 'field.maxWinDay',
      rules: 'decimal:2',
      type: 'currency',
    },
  ] : []),
  ...(games.includes(GAME.Sport99) ? [
    {
      label: 'breadcrumb.sport99',
      icon: 'TvIcon',
      type: 'divider',
    },
    {
      key: 'maxBetTimeSport99',
      label: 'field.maxBetTime',
      rules: 'decimal:2',
      type: 'currency',
    },
  ] : []),
  {
    label: 'breadcrumb.accountInformation',
    icon: 'LockIcon',
    type: 'divider',
  },
  {
    key: 'parentId',
    label: 'field.underAccount',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'agent',
    selectionKey: 'id',
    selectionLabel: 'username',
  },
  {
    key: 'username',
    label: 'field.username',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'password',
    name: 'new-password',
    label: 'field.password',
    rules: 'required|min:6',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'retypePassword',
    label: 'field.retypePassword',
    rules: 'required|confirmed:password',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
  {
    key: 'isReadonly',
    label: 'status.readonly',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]
